import { useState } from "react";
import ContactUsForm from "@/components/ContactUsForm";
import PartnershipForm from "@/components/PartnershipForm";

export default function ContactUsPage() {
    const [activeTab, setActiveTab] = useState("contact");
    const [isSuccess, setIsSuccess] = useState(false);

    const handleSuccess = () => {
        setIsSuccess(true);
    };

    if (isSuccess) {
        return (
            <div className="main">
                <div className="container-fluid contact-form-header">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 mt-5">
                                <h1>Contact Us</h1>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container-fluid contact-form">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <div className="d-flex flex-column align-items-left">
                                    <h2 className="h3 mb-3">
                                        Thank You!
                                    </h2>
                                    <p className="text-muted mb-4">
                                        We have received your message and we will get back to you shortly.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="main">
            <div className="container-fluid contact-form-header">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <h1>Contact Us</h1>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container-fluid contact-form">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <ul className="nav nav-pills nav-fill form-nav" id="pills-tab" role="tablist">
                                <li className="nav-item form-nav-header" role="presentation">
                                    <button
                                        className={`nav-link ${activeTab === "contact" ? "active" : ""}`}
                                        id="pills-contact-tab"
                                        type="button"
                                        role="tab"
                                        aria-controls="pills-contact"
                                        aria-selected={activeTab === "contact"}
                                        onClick={() => setActiveTab("contact")}
                                    >
                                        Contact Us
                                    </button>
                                </li>
                                <li className="nav-item form-nav-header" role="presentation">
                                    <button
                                        className={`nav-link ${activeTab === "partnership" ? "active" : ""}`}
                                        id="pills-partnership-tab"
                                        type="button"
                                        role="tab"
                                        aria-controls="pills-partnership"
                                        aria-selected={activeTab === "partnership"}
                                        onClick={() => setActiveTab("partnership")}
                                    >
                                        For Partnerships (Airlines, Ground Handling Companies, Airports, Clinics)
                                    </button>
                                </li>
                            </ul>

                            <div className="tab-content" id="pills-tabContent">
                                <div
                                    className={`tab-pane fade ${activeTab === "contact" ? "show active" : ""}`}
                                    id="pills-contact"
                                    role="tabpanel"
                                    aria-labelledby="pills-contact-tab"
                                    tabIndex={0}
                                >
                                    <ContactUsForm onSuccess={handleSuccess} />
                                </div>
                                <div
                                    className={`tab-pane fade ${activeTab === "partnership" ? "show active" : ""}`}
                                    id="pills-partnership"
                                    role="tabpanel"
                                    aria-labelledby="pills-partnership-tab"
                                    tabIndex={0}
                                >
                                    <PartnershipForm onSuccess={handleSuccess} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}